<script>
import moment from "moment";
import SvgIcon from "../common/SvgIcon.vue";
moment.locale("id");
export default {
  components: { SvgIcon },
  name: "PembinaanCard",
  props: {
    training: Object,
  },
  computed: {
    statusEvent() {
      if (this.training?.status === "publish") {
        return 'Pendaftaran Dibuka'
      }
      if (this.training?.status === "finish") {
        return 'Selesai';
      }
      return 'Selesai';
    },
  },
  methods: {
    convertDate(date) {
      return moment(date).format("LL");
    },
  },
};
</script>
<template>
  <div class="training-card" :class="{ 'training-card--finished': training.status == 'finish' }">
    <div class="training-card__thumbnail">
      <img :src="training.cover" alt="" />
      <div class="training-card--image-overlay" v-if="training.status == 'finish'">
        <span class="training-card--finished-label">Selesai</span>
      </div>
      <span
        class="training-card__status-badge"
        :class="training.status == 'publish' ? 'training-card__status-badge--open' : 'training-card__status-badge--closed'"
      >
        {{ statusEvent }}
      </span>
    </div>
    <div class="training-card__body">
      <h6 class="font-weight-bold training-card--title mb-1" v-html="training.title"></h6>
      <p class="text-muted training-card--subtitle mb-2" v-if="training.subtitle">
        {{ training.subtitle }}
      </p>
      <div class="training-card__info">
        <div class="training-card__info-item">
          <svg-icon name="calendar-check" class="training-card__info-icon" />
          <div>
            <div>{{ convertDate(training.start) }}</div>
            <div class="font-weight-bold">
              {{ training.start ? training.start.substr(10, 6) : '' }} -
              {{ training.end ? training.end.substr(10, 6) : '' }}
            </div>
          </div>
        </div>
        <div class="training-card__info-item">
          <svg-icon name="map-pin" class="training-card__info-icon" />
          <div>{{ training.location || "Belum ditentukan" }}</div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mt-2">
        <span class="text-muted training-card__kuota">
          <svg-icon name="user-three" style="width:1.1rem;" />
          <span class="pl-1">
            {{ training.seats - training.registered > 0 ? training.seats - training.registered : 0 }} kuota
          </span>
        </span>
        <router-link
          :to="{ path: '/pelaku/pembinaan/detail', query: { id: training.id } }"
          class="btn btn-sm training-card__cta"
          :class="training.status == 'finish' ? 'btn-outline-secondary' : 'btn-primary'"
        >
          Selengkapnya <i class="fas fa-arrow-right fa-xs ml-1"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.training-card {
  border-radius: 0.875rem;
  border: 1px solid #eaedf3;
  overflow: hidden;
  background: #fff;
  transition: box-shadow 0.2s, transform 0.2s;

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }

  &--finished {
    border-color: #e9e9e9;
    background: #fafafa;
    opacity: 0.85;
  }

  &__thumbnail {
    position: relative;
    overflow: hidden;
    height: 160px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s;
    }

    &:hover img {
      transform: scale(1.05);
    }
  }

  &--image-overlay {
    position: absolute;
    inset: 0;
    background: rgba(50, 50, 50, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  &--finished-label {
    background: rgba(255,255,255,0.15);
    color: #fff;
    font-weight: 600;
    font-size: 0.85rem;
    padding: 0.3rem 1rem;
    border-radius: 2rem;
    border: 1px solid rgba(255,255,255,0.4);
    letter-spacing: 0.5px;
  }

  &__status-badge {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    font-size: 0.7rem;
    font-weight: 600;
    padding: 0.2rem 0.6rem;
    border-radius: 2rem;

    &--open {
      background: #eafff3;
      color: #219653;
    }
    &--closed {
      background: #ffe3e3;
      color: #eb5757;
    }
  }

  &--title {
    font-size: 0.9rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.4;
  }

  &--subtitle {
    font-size: 0.78rem;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__body {
    padding: 0.75rem;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    background: #f8f9fb;
    border-radius: 0.5rem;
    padding: 0.5rem 0.625rem;
    margin-bottom: 0;
  }

  &__info-item {
    display: flex;
    align-items: flex-start;
    gap: 0.4rem;
    font-size: 0.75rem;
    color: #555;
  }

  &__info-icon {
    height: 1.1rem;
    width: 1.1rem !important;
    flex-shrink: 0;
    margin-top: 2px;
  }

  &__kuota {
    font-size: 0.75rem;
    display: flex;
    align-items: center;
  }

  &__cta {
    font-size: 0.78rem;
    padding: 0.3rem 0.75rem;
    border-radius: 0.5rem;
    white-space: nowrap;
  }
}
</style>
